/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { getCustomerBusinessStatisticalData } from '@/api/customer'
import * as echarts from 'echarts';

import {
    thisWeek,
    lastWeek,
    thisMonth,
    lastMonth,
    thisQuarter,
    lastQuarter,
    thisYear,
    lastYear,
    thisToday,
    thisYesterday
} from '@/utils/dateTime.ts'

@Component({})
export default class AddBClassifyCustomer extends Vue {
    timeType = '1'
    pageTypeData = null
    marketCooperationIsSingList = []
    customerBusinessIsSignPriceSumGroupByUserList = []
    timeStr = ''
    typeIsShow = false
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    timeStrDate = []
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    tableData = []

    created() {
        this.getDateInterval()
    }

    mounted() {
        // this.getCustomeData()
    }
   // 选择区间
    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek,this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth,this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter,this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear,this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek,this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth,this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter,this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart,this.yesteryearEnd]
        }else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday,this.yesterday]
        }else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today,this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }


        if (this.timeStr) {
            this.getCustomeData()
        }

    }

    handleChangeData(val) {
        const  week = [this.startWeek,this.endWeek]
        const  month = [this.startMonth,this.endMonth]
        const  year = [this.startYear,this.endYear]
        const  quarter = [this.startQuarter,this.endQuarter]
        const  lastWeek = [this.startLastWeek,this.endLastWeek]
        const  lastMonth = [this.startLastMonth,this.endLastMonth]
        const  lastQuarter = [this.startLastQuarter,this.endLastQuarter]
        const  lastyear = [this.yesteryearStart,this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        }  else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        }else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        this.getCustomeData()
    }

    async getCustomeData() {
        const loading = this.$loading({
            lock: true,
            text: '正在获取数据，请耐心等待',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        const obj = {
            timeStr: this.timeStr
        }
        const result: any = await getCustomerBusinessStatisticalData(obj)
        this.pageTypeData = result

        const {
            customerBusinessPriceGroupByUser,
            customerBusinessListGroupByUser,
            customerBusinessGroupByGradeCountList,
            customerBusinessGroupByIntentionalityCountList,
            customerBusinessGroupBySourceTypeCountList,
            customerBusinessGroupByCourseTypeIdCountList,
            customerBusinessGroupByEduTemandCountList
        } = result
        // 录入签约表
        this.tableData = customerBusinessListGroupByUser
       this.typeIsShow = this.pageTypeData.isShow
        this.$nextTick(() => {

            this.initOrderBackEcharts(customerBusinessPriceGroupByUser) // 订单-回款
            this.initSignCustomerEcharts(customerBusinessListGroupByUser) // 录入-签约
            this.initgradeCustomterRatio(customerBusinessGroupByGradeCountList) // 客户年级占比
            this.initIntentionRatio(customerBusinessGroupByIntentionalityCountList) // 意向度
            this.initCustomterSourceRatio(customerBusinessGroupBySourceTypeCountList) // 客户来源渠道占比
            this.initCourseTypeRatio(customerBusinessGroupByCourseTypeIdCountList) // 意向项目类型
            this.initEduTemandRatio(customerBusinessGroupByEduTemandCountList) // 意向项目类型


        })
        setTimeout(() => {
            loading.close();
        }, 2000);
    }
    // 背景长度比例
    smallitemwidth(item: any, index: any, list: any) {
        const pxlist: any = (item.price / list[0].price) * 120
        return (item.backPrice / item.price) * pxlist + 'px'
    }
    // 背景长度比例
    bigitemwidth(item: any, index: any, list: any) {
        if (index !== 0) {
            return (item.price / list[0].price) * 120 + 'px'
        }
    }
    // bigbackground(index: any) {
    //     if (index === 1) {
    //         return '#97FFDB'
    //     } else if (index === 2) {
    //         return '#97C2FF'
    //
    //     } else if (index === 3) {
    //         return '#FF8888'
    //
    //     } else if (index === 4) {
    //         return '#97AEFF'
    //     } else {
    //         return '#F9B2B2'
    //     }
    // }
    smallbackground(index: any) {
        if (index === 1) {
            return '#0DFFAB'
        } else if (index === 2) {
            return '#227EFF'

        } else if (index === 3) {
            return '#FF0A0A'

        } else if (index === 4) {
            return '#567BFF'
        } else {
            return '#FF7272'
        }
    }





//    初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '0') {
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
            this.getCustomeData()
        } else if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            this.getCustomeData()
        }

    }




//    初始化订单-回款金额统计图
    initOrderBackEcharts(arr){
        let data = []

        if (arr.length > 0) {
            data = arr.map(item => ({
                'product': item.directorUserRealName,
                '订单金额': item.financeOrderSum,
                '回款金额': item.customerBusinessBackPriceSum
            }))

        } else {
            data = [{'product': '某某员工', '订单金额': 0, '回款金额': 0}]
        }

        const chartDom = document.getElementById('orderBack');
        const myChart = echarts.init(chartDom);

        myChart.on('legendselectchanged', (obj: any) => {
            if (obj.selected.回款金额 && !obj.selected.订单金额) {
                const op = myChart.getOption();
                op.series[1].markLine.data[0].lineStyle.opacity = 1
                myChart.setOption(op, true);
            } else if (!obj.selected.回款金额 && obj.selected.订单金额 ) {
                const op = myChart.getOption();
                op.series[0].markLine.data[0].lineStyle.opacity = 1
                myChart.setOption(op, true);
            } else {
                const op = myChart.getOption();
                op.series[0].markLine.data[0].lineStyle.opacity = 0
                op.series[1].markLine.data[0].lineStyle.opacity = 0
                myChart.setOption(op, true);
            }
        })

        const option = {
            title: {
                subtext: '订单-回款金额'
            },
            legend: {
                right: 5,
                // selected: {
                //     '订单金额': true,
                //     '回款金额': true,
                // },
                // data: ['订单金额', '回款金额']
            },
            tooltip: {
                // trigger: 'item',
                // show: true,
            },
            dataset: {
                dimensions: ['product', '订单金额', '回款金额'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '员工姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0, 0, 0, 20]
                },
                triggerEvent: true,

            },
            yAxis: [
                {type: 'value',minInterval: 10,splitNumber: 10},
                {type: 'value',axisLabel: {show: true,interval: 'auto',formatter: '{value} %'},}
            ],
            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: {color: '#7bbfea'},
                    label: {show: true, position: 'top'},
                    markLine: {data: [{type: 'average', name: 'Avg', lineStyle: {normal: {opacity: 0}}}]}
                },
                {
                    name: '回款金额',
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: {color: '#65c294'},
                    label: {show: true, position: 'top'},
                    markLine: {data: [{type: 'average', name: 'Avg', lineStyle: {normal: {opacity: 0}}}]}
                },
            ]
        }

        option && myChart.setOption(option);

    }

    // 初始化 录入-签约客户
    initSignCustomerEcharts(arr){
        let data = []
        // const arr = array.customerConversionGroupByUserIdList
        if (arr.length > 0) {
            data = arr.map(item => ({
                'product': item.directorUserRealName,
                '录入客户': item.customerBusinessCount,
                '签约客户': item.customerBusinessIsSignCount
            }))
            // data = array.map(item => ({ 'product': item.userRealName, '客户数': item.customerConversionCount, '签约数': item.marketClueIsSignCount, '签约率': item.marketClueIsSignCount }))
            // dataPercentage = array.map(item => ({ '签约率': item.marketClueIsSignCount }))
        } else {
            data = [{'product': '某某员工', '录入客户': 0, '签约客户': 0}]
        }

        const chartDom = document.getElementById('signCustomter');
        const myChart = echarts.init(chartDom);

        myChart.on('legendselectchanged', (obj : any) => {
            if (obj.selected.签约客户 && !obj.selected.录入客户) {
                const op = myChart.getOption();
                op.series[1].markLine.data[0].lineStyle.opacity = 1
                myChart.setOption(op, true);
            } else if (!obj.selected.签约客户 && obj.selected.录入客户 ) {
                const op = myChart.getOption();
                op.series[0].markLine.data[0].lineStyle.opacity = 1
                myChart.setOption(op, true);
            } else {
                const op = myChart.getOption();
                op.series[0].markLine.data[0].lineStyle.opacity = 0
                op.series[1].markLine.data[0].lineStyle.opacity = 0
                myChart.setOption(op, true);
            }
        })
        const option = {
            title: {
                subtext: '录入-签约客户'
            },
            legend: {
                right: 5,

            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            dataset: {
                dimensions: ['product', '录入客户', '签约客户'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '员工姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0, 0, 0, 20]
                },
                triggerEvent: true,
                axisLabel: {
                    show: true,

                    interval: 0,
                    clickable: true,
                    formatter: function (value,index) {
                        let ret = "";//拼接加\n返回的类目项
                        const maxLength = 1;//每项显示文字个数
                        const valLength = value.length;//X轴类目项的文字个数
                        const rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                        if (rowN > 1)//如果类目项的文字大于3,
                        {
                            for (let i = 0; i < rowN; i++) {
                                let temp = "";//每次截取的字符串
                                const start = i * maxLength;//开始截取的位置
                                const end = start + maxLength;//结束截取的位置
                                //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                                temp = value.substring(start, end) + "\n";
                                ret += temp; //凭借最终的字符串
                            }
                            return ret;
                        }
                        else {
                            return value;
                        }
                    }
                }
            },
            yAxis: [
                {type: 'value',minInterval: 10,splitNumber: 10},

            ],
            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: {color: '#f57449', opacity: 0.7},
                    label: {show: true, position: 'top'},
                    markLine: {data: [{type: 'average', name: 'Avg', lineStyle: {normal: {opacity: 0}}}]}
                },
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: {color: '#f1b00a', opacity: 0.7},
                    label: {show: true, position: 'top'},
                    markLine: {data: [{type: 'average', name: 'Avg', lineStyle: {normal: {opacity: 0}}}]}
                }

            ]
        }

        option && myChart.setOption(option);

    }

    // 初始化客户年级占比
    initgradeCustomterRatio(array) {
        let data = []

        let total = 0
        if (array.length > 0) {
            data = array.map(item => ({name: item.grade, value: item.count}))
            array.forEach(item => {
                total += Number(item.count)
            })
        } else {
            data.push({name: '某某年级', value: 0})
        }
        const chartDom = document.getElementById('gradeCustomter');
        const myChart = echarts.init(chartDom);
        const option = {
            title: {
                text: '客户年级占比',
                left: 'left'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 'right'
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                const colorarrays = [
                                    '#FFE1E1', '#ACFAA1', '#FFEE28', '#FF8F8F', '#DEB887',
                                    '#87CEFF', '#90EE90', '#40E0D0', '#BCEE68', '#EEE685',
                                    '#FFA07A', '#FFB6C1', '#D8BFD8', '#EEA2AD', '#FFBBFF',
                                    '#FFD700', '#F5F5DC', '#D2B48C', '#DA70D6', '#F0FFF0',
                                ];
                                return colorarrays[params.dataIndex];
                            }
                        },
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        align: 'center',
                        fontSize: 10,
                        formatter: (params) => {
                            let str = params.data.name + '\n'
                            if (params.data.value > 0) {
                                str += '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    }
                }
            ]
        };

        option && myChart.setOption(option);

    }

    // 初始化客户来源渠道占比
    initCustomterSourceRatio(array) {
        let data = []

        let total = 0
        if (array.length > 0) {
            data = array.map(item => ({name: item.sourceType, value: item.count}))
            array.forEach(item => {
                total += Number(item.count)
            })
        } else {
            data.push({name: '某某渠道', value: 0})
        }
        const chartDom = document.getElementById('sourceChannelCustomter');
        const myChart = echarts.init(chartDom);
        const option = {
            title: {
                text: '客户来源渠道占比',
                left: 'left'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 'right'
            },
            color: [
                '#FFE1E1', '#ACFAA1', '#FFEE28', '#FF8F8F','#DEB887',
                '#87CEFF','#90EE90','#40E0D0','#BCEE68','#EEE685',
                '#FFA07A','#FFB6C1','#D8BFD8','#EEA2AD','#FFBBFF',
                '#FFD700','#F5F5DC','#D2B48C','#DA70D6','#F0FFF0',
            ],
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    // itemStyle:{
                    //     color: function (value) {
                    //         return "#" + ("00000" + ((Math.random() * 16777215 + 0.5) >> 0).toString(16)).slice(-6);
                    //     },
                    // },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        align: 'center',
                        fontSize: 10,
                        formatter: (params) => {
                            let str = params.data.name + '\n'
                            if (params.data.value > 0) {
                                str += '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    }
                }
            ]
        };

        option && myChart.setOption(option);

    }

    // 初始化意向项目占比
    initCourseTypeRatio(array) {
        let data = []

        let total = 0
        if (array.length > 0) {
            data = array.map(item => ({name: item.courseTypeId, value: item.count}))
            array.forEach(item => {
                total += Number(item.count)
            })
        } else {
            data.push({name: '某某意向项目类型', value: 0})
        }
        const chartDom = document.getElementById('courseType');
        const myChart = echarts.init(chartDom);
        const option = {
            title: {
                text: '意向项目类型占比',
                left: 'left'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 'right'
            },
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                const colorarrays = [
                                    '#FFE1E1', '#ACFAA1', '#FFEE28', '#FF8F8F', '#DEB887',
                                    '#87CEFF', '#90EE90', '#40E0D0', '#BCEE68', '#EEE685',
                                    '#FFA07A', '#FFB6C1', '#D8BFD8', '#EEA2AD', '#FFBBFF',
                                    '#FFD700', '#F5F5DC', '#D2B48C', '#DA70D6', '#F0FFF0',
                                ];
                                return colorarrays[params.dataIndex];
                            }
                        },
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        align: 'center',
                        fontSize: 10,
                        formatter: (params) => {
                            let str = params.data.name + '\n'
                            if (params.data.value > 0) {
                                str += '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    }
                }
            ]
        };

        option && myChart.setOption(option);

    }

    // 初始化意向程度占比
    initIntentionRatio(array) {
        let data = []

        let total = 0
        if (array.length > 0) {
            data = array.map(item => ({name: item.intentionality, value: item.count}))
            array.forEach(item => {
                total += Number(item.count)
            })
        } else {
            data.push({name: '意向度', value: 0})
        }
        const chartDom = document.getElementById('intention');
        const myChart = echarts.init(chartDom);
        const option = {
            title: {
                text: '意向度占比',
                left: 'left'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 'right'
            },
            color: [
                '#FFE1E1', '#ACFAA1', '#FFEE28', '#FF8F8F','#DEB887',
                '#87CEFF','#90EE90','#40E0D0','#BCEE68','#EEE685',
                '#FFA07A','#FFB6C1','#D8BFD8','#EEA2AD','#FFBBFF',
                '#FFD700','#F5F5DC','#D2B48C','#DA70D6','#F0FFF0',
            ],
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    // itemStyle:{
                    //     color: function (value) {
                    //         return "#" + ("00000" + ((Math.random() * 16777215 + 0.5) >> 0).toString(16)).slice(-6);
                    //     },
                    // },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        align: 'center',
                        fontSize: 10,
                        formatter: (params) => {
                            let str = params.data.name + '\n'
                            if (params.data.value > 0) {
                                str += '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    }
                }
            ]
        };

        option && myChart.setOption(option);

    }

    // 初始化升学需求占比
    initEduTemandRatio(array) {
        let data = []

        let total = 0
        if (array.length > 0) {
            data = array.map(item => ({name: item.eduTemand, value: item.count}))
            array.forEach(item => {
                total += Number(item.count)
            })
        } else {
            data.push({name: '升学需求', value: 0})
        }
        const chartDom = document.getElementById('eduTemand');
        const myChart = echarts.init(chartDom);
        const option = {
            title: {
                text: '升学需求占比',
                left: 'left'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 'right'
            },
            color: [
                '#FFE1E1', '#ACFAA1', '#FFEE28', '#FF8F8F','#DEB887',
                '#87CEFF','#90EE90','#40E0D0','#BCEE68','#EEE685',
                '#FFA07A','#FFB6C1','#D8BFD8','#EEA2AD','#FFBBFF',
                '#FFD700','#F5F5DC','#D2B48C','#DA70D6','#F0FFF0',
            ],
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    // itemStyle:{
                    //     color: function (value) {
                    //         return "#" + ("00000" + ((Math.random() * 16777215 + 0.5) >> 0).toString(16)).slice(-6);
                    //     },
                    // },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        align: 'center',
                        fontSize: 10,
                        formatter: (params) => {
                            let str = params.data.name + '\n'
                            if (params.data.value > 0) {
                                str += '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    }
                }
            ]
        };

        option && myChart.setOption(option);

    }
}
